import { useLazyQuery } from "@apollo/client";
import { clientCentralApiStrawberry } from "@neonumy/api-clients";
import { TransferItem } from "antd5/es/transfer";
import { LIST_ACCOUNTING_FIRMS_SELECT_QUERY } from "queries/centralapi/accountingFirms";
import { useEffect, useState } from "react";
import {
  GetAccountingFirmsOptionsInput,
  GetAccountingFirmsOptionsOutput,
} from "types/queries/centralapi/accountingFirm";
import { onErrorGraphql } from "utils/onErrorGraphql";

export function useNewUserWorkSettings() {
  const [accounfingFirmsData, setAccounfingFirmsData] = useState<TransferItem[]>([]);

  const [listAccountingFirms, { data: accountingFirmsData, error: accountingFirmsError }] =
    useLazyQuery<GetAccountingFirmsOptionsOutput, GetAccountingFirmsOptionsInput>(
      LIST_ACCOUNTING_FIRMS_SELECT_QUERY,
      { client: clientCentralApiStrawberry },
    );

  useEffect(() => {
    if (accountingFirmsData) {
      setAccounfingFirmsData(
        accountingFirmsData.listAccountingFirmsPaginated.results.map(item => ({
          key: item.id,
          title: item.name,
          id: item.id,
        })),
      );
    }
  }, [accountingFirmsData]);

  useEffect(() => {
    if (accountingFirmsError) onErrorGraphql(accountingFirmsError);
  }, [accountingFirmsError]);

  useEffect(() => {
    listAccountingFirms({ variables: { limit: 5000, offset: 0 } });
  }, []);

  const filterOption = (inputValue: string, item: TransferItem): boolean =>
    item.title?.toLowerCase().includes(inputValue) || false;

  return { accounfingFirmsData, filterOption };
}
